import React from 'react';

const Services = () => (
  <div id="services" className="space-medium">
    <div className="container">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
          {/* section heading start */}
          <div className="section-heading">
            <h2 className="section-heading-title">Our Services</h2>
            <p className="section-heading-text">
                Faster detection and faster response to protect against cyber threats and suspicious activities. Without investing in expensive technologies or add security resources.
            </p>
            {/* section heading close */}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          {/* feature block start */}
          <div className="feature-block-v3 feature-block border-bottom-4 bb-brand-color">
            <div className="feature-content">
              <h4 className="feature-title">Compliance</h4>
              <div className="bullet-list">
                <ul className="arrow list-unstyled">
                  <li>ISO 27001</li>
                  <li>PCI DSS</li>
                  <li>NESA / ISR</li>
                </ul>
              </div>
            </div>
          </div>
          {/* feature block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          {/* feature block start */}
          <div className="feature-block-v3 feature-block border-bottom-4 bb-brand-color">
            <div className="feature-content">
              <h4 className="feature-title">Audit</h4>
              <div className="bullet-list">
                <ul className="arrow list-unstyled">
                  <li>IS Audit (Internal, Process, Application Process, RA)</li>
                  <li>Vendor Risk Management</li>
                </ul>
              </div>
            </div>
          </div>
          {/* feature block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          {/* feature block start */}
          <div className="feature-block-v3 feature-block border-bottom-4 bb-brand-color">
            <div className="feature-content">
              <h4 className="feature-title">Data Security</h4>
              <div className="bullet-list">
                <ul className="arrow list-unstyled">
                  <li>GDPR</li>
                  <li>HIPAA</li>
                  <li>HITRUST</li>
                </ul>
              </div>
            </div>
          </div>
          {/* feature block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          {/* feature block start */}
          <div className="feature-block-v3 feature-block border-bottom-4 bb-brand-color">
            <div className="feature-content">
              <h4 className="feature-title">MDR Consulting</h4>
              <div className="bullet-list">
                <ul className="arrow list-unstyled">
                  <li>Maturity Improvement Pack</li>
                  <li>Advanced SOC Transformation / MDR Maturity Assessment</li>
                </ul>
              </div>
            </div>
          </div>
          {/* feature block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          {/* feature block start */}
          <div className="feature-block-v3 feature-block border-bottom-4 bb-brand-color">
            <div className="feature-content">
              <h4 className="feature-title">Cloud Security</h4>
              <div className="bullet-list">
                <ul className="arrow list-unstyled">
                  <li>Cloud Security Assessment</li>
                  <li>CSA Star Compliance</li>
                  <li>ISO 27017 / ISO 27018</li>
                </ul>
              </div>
            </div>
          </div>
          {/* feature block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          {/* feature block start */}
          <div className="feature-block-v3 feature-block border-bottom-4 bb-brand-color">
            <div className="feature-content">
              <h4 className="feature-title">vCISO</h4>
              <div className="bullet-list">
                <ul className="arrow list-unstyled">
                  <li>Year long program, remote driven CISO function covering risk & compliance.</li>
                </ul>
              </div>
            </div>
          </div>
          {/* feature block close */}
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center m-t-40">
          <a href="#" className="btn btn-rounded btn-brand btn-lg">Request a Free Demo</a>
        </div>
      </div>
    </div>
  </div>

);

export default Services;
